module.exports = __webpack_public_path__ + "img/logo.4ec53d46.png";